import React from 'react';

import { SambaAutoLink } from '@betterment/shared-components';

import RewardGiftBoxImage from '../images/reward_gift_box.png';
import RewardGiftBoxMobileImage from '../images/reward_gift_box_wide.png';
import RateBoostPercent75Image from '../images/rewards_center_images/cash_rate_boost.png';
import { urlBuilder } from '../Shared/urlBuilder';

export type ExpiredSenderOfferName = 'referral_sender_q4_2018' | 'referral_sender_rate_boost_q1_2024';
export type ActiveSenderOfferName = 'referral_sender_dmf_q4_2019' | 'referral_sender_rate_boost_q4_2025';

export type SenderOfferName = ExpiredSenderOfferName | ActiveSenderOfferName;

export interface ReferralSenderOfferName {
  senderOfferName: ActiveSenderOfferName | null;
}

export type Status = 'funded' | 'signed_up' | 'sent' | 'prompt';

export interface ReferralKey {
  referralKey: string;
}

export interface InviteParams {
  receivingUserEmail: string;
}

export interface Referral {
  email: string;
  status: Status;
  personalReferralInviteId: string | null;
}

export type SenderOfferFulfillment = {
  status: 'Upcoming' | 'Active' | 'Expired' | 'Pending';
  displayReward: string;
  rewardType: 'free_dollars_fixed' | 'free_time' | 'savings_rate_boost';
  startDate: string;
  endDate: string;
  offerName: SenderOfferName;
};

export type ReferralSenderOfferDetails = {
  name: ActiveSenderOfferName;
  title: string;
  description: string;
  additionalDescription?: React.ReactNode;
  limitedTime: boolean;
  featuredImage: {
    image: string;
    mobile: string;
    alt: string;
  };
};

export const REFERRAL_SENDER_OFFER_LOOKUP: Record<ActiveSenderOfferName, ReferralSenderOfferDetails> = {
  referral_sender_dmf_q4_2019: {
    name: 'referral_sender_dmf_q4_2019',
    title: 'Get up to $25,000 of your investments managed for free',
    description:
      "Refer a friend to sign up for Betterment, and we'll manage $5,000 of your investment balance free for a year. Limit five referrals for a total of $25,000 investment dollars managed.",
    limitedTime: false,
    featuredImage: {
      image: RewardGiftBoxImage,
      mobile: RewardGiftBoxMobileImage,
      alt: 'hand with gift box',
    },
  },
  referral_sender_rate_boost_q4_2025: {
    name: 'referral_sender_rate_boost_q4_2025',
    title: 'Get up to 4.00% variable APY for 3 months',
    description:
      "Refer a friend to Betterment and you'll both receive a 0.75% APY boost on Cash Reserve. You'll get the boost when your friend signs up and funds a qualifying account within 7 days. Limit one boost per customer.",
    additionalDescription: (
      <>
        Boost applies to balances up to $150,000.{' '}
        <SambaAutoLink to={urlBuilder.getOfferTerms.absolute({ offerName: 'referral_sender_rate_boost_q4_2025' })}>
          Terms Apply.
        </SambaAutoLink>
      </>
    ),
    limitedTime: true,
    featuredImage: {
      image: RateBoostPercent75Image,
      mobile: RateBoostPercent75Image,
      alt: '+0.75% APY',
    },
  },
};
